module.exports = __webpack_public_path__ + "fo.svg?4bd8156d13fe51d871b78678438f8827";


//////////////////
// WEBPACK FOOTER
// ./src/images/flags/4x3/fo.svg
// module id = 1249
// module chunks = 27